module.exports = __webpack_public_path__ + "img/accolade.e3ecda7f.svg";